// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import DeleteLight from '../_raw/ui/icon_delete_light.svg';
import withIconProps from '../withIconProps';

export default withIconProps(DeleteLight);
